import React, { useState, useEffect } from "react";
import styles from "../checkout.module.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isCardEmtpy } from "../../../constant/utils";

interface IPayOption {
  totalPayble: number;
  bookingData: any;
  setBookingData: (val: any) => void;
  handleCreateBooking: (val?: any) => void;
}
const Payoption = ({ totalPayble = 0, bookingData, setBookingData, handleCreateBooking }: IPayOption) => {
  const [isModify, setIsModify] = useState<boolean>(false);
  const checkoutLoading: boolean = useSelector((state: any) => state.checkout.checkoutLoading || false);
  // console.log(bookingData, "dqqdwqd")
  const bookingValidation: any = useSelector((state: any) =>
    state.checkout.bookingValidation ? state.checkout.bookingValidation : {}
  );
  useEffect(() => {
    if (totalPayble <= 0 && bookingData?.isBookingEdit) {
      setBookingData({ ...bookingData, PaymentMode: "cod" });
    }
  }, [totalPayble, bookingData?.isBookingEdit, bookingData?.CardData]);

  useEffect(() => {
    if (bookingData?.isBookingEdit) {
      if (
        bookingData?.selectedAddress?.id != bookingData?.bookingEditData?.address_id ||
        bookingData?.selectedMember?.details?.id != bookingData?.bookingEditData?.patient_id ||
        bookingData?.ScheduleDate != bookingData?.bookingEditData?.schedule_date ||
        bookingData?.ScheduleTime != bookingData?.bookingEditData?.schedule_time_new ||
        compareArr(JSON.parse(localStorage.getItem("CartData") || "[]"), editBookingOldData())
      ) {
        setIsModify(true);
      } else {
        setIsModify(false);
      }
    }
  }, [bookingData]);

  function editBookingOldData() {
    let test: any[] = JSON.parse(bookingData?.bookingEditData?.updated_order_details || "[]");
    // return test?.filter((item:any) => item?.code !== "G06S07T77");
    return test?.filter(
      (item: any) => !item?.code.includes(bookingValidation?.homeCollectionCharges?.test_code || "G06S07T77")
    );
  }
  function compareArr(a: any[], b: any[]) {
    console.log(a, b);
    if (a?.length !== b.length) {
      return true;
    } else {
      let isMatch: boolean = false;
      for (let i = 0; i < a.length; i++) {
        let _find = b.find((eleIn: any) => eleIn?.code == a[i]?.TestCode);
        if (!_find) {
          isMatch = true;
          break;
        }
      }
      return isMatch;
    }
  }
  return (
    <div>
      {totalPayble >= 0 ? (
        <div className={styles.payTopHeading}>
          <span>Total Payable Amount</span>
          <span>₹{totalPayble}/-</span>
        </div>
      ) : (
        <div className={styles.payTopHeading}>
          <span>Total Refundable Amount</span>
          <span>₹{totalPayble?.toString()?.replace("-", "")}/-</span>
        </div>
      )}
      <hr className={styles.payHr} />
      {isCardEmtpy(false) ? (
        <div className={styles.payOptionbox}>
          <div className={styles.cardEmptyMessage}>Your Card is empty you can't proceed.</div>
        </div>
      ) : (
        <div className={styles.payOptionbox}>
          {totalPayble <= 0 ? (
            <div className={styles.noNeedToPay}>
              {totalPayble == 0 ? "Your amount is already paid, No need to pay Extra amount." : ""}
            </div>
          ) : (
            <>
              <div className={styles.payMidHeading}>Choose Payment Method:</div>
              <div className={styles.payRadio}>
                {bookingValidation?.orderStatusInCity?.isPaymentActive && (
                  <div>
                    <input
                      name="payType"
                      type="radio"
                      id="online"
                      value="online"
                      checked={bookingData?.PaymentMode == "online"}
                      onChange={(e: any) => {
                        setBookingData({
                          ...bookingData,
                          PaymentMode: e.target.value,
                        });
                      }}
                      disabled={totalPayble <= 0}
                    />
                    <label htmlFor="online">
                      Credit card/Debit card/Net Banking
                      <img src="assets/img/my-profile/upi.png" style={{ width: "14%" }} />
                      <img src="assets/img/my-profile/paytm.png" height={24} />
                      <div className={styles?.onlineInfoText}>
                        Pay securely by Credit or Debit or Internet Banking through Easebuzz
                      </div>
                    </label>
                  </div>
                )}
                <div>
                  <input
                    name="payType"
                    type="radio"
                    id="offline"
                    value="cod"
                    checked={bookingData?.PaymentMode == "cod"}
                    onChange={(e: any) => {
                      setBookingData({ ...bookingData, PaymentMode: e.target.value });
                    }}
                    disabled={totalPayble <= 0}
                  />
                  <label htmlFor="offline">Pay at Sample Pickup</label>
                </div>
              </div>
            </>
          )}
          <button
            type="button"
            className="book--hexagon active"
            style={{ padding: "6px 25px", margin: 0 }}
            onClick={handleCreateBooking}
            disabled={
              checkoutLoading
                ? true
                : bookingData?.isBookingEdit &&
                  bookingData?.bookingEditData?.payment_type == "cod" &&
                  totalPayble > 0 &&
                  bookingData?.PaymentMode == "online"
                ? false
                : bookingData?.isBookingEdit && !isModify && bookingData?.PaymentMode
                ? true
                : !(bookingData?.PaymentMode && bookingData?.ScheduleDate && bookingData?.ScheduleTime)
                ? true
                : false
            }
          >
            <span className="text-capitalize">
              {checkoutLoading ? "Loading..." : bookingData?.isBookingEdit ? "Update Booking" : "Book Now"}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Payoption;
